export default __webpack_public_path__ + "static/media/hbs-bpk-1.210e5d11.png";